import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { TransactionListInterface } from '../types/transaction-list';
import {
  TransactionListFilter,
  defaultTransactionListFilter,
} from '../types/transaction-list-filter';

export const TRANSACTION_LIST_STATE = 'transactionList';

export interface TransactionListState {
  filter: TransactionListFilter;
  dataSource: DataSource<TransactionListInterface[]>;
}

export const initialDataSource: DataSource<TransactionListInterface[]> =
  Object.freeze({
    ...initialPageableData,
    rawData: [],
  });

export const initialTransactionListState: TransactionListState = Object.freeze({
  filter: defaultTransactionListFilter,
  dataSource: {
    ...initialDataSource,
  },
});
